<template>
  <el-container class="homePage">
    <el-aside width>
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        :collapse="true"
        :background-color="'var(--themeColor)'"
        router
      >
        <el-popover
          placement="right"
          width="200"
          trigger="hover"
          popper-class="logoPopBox"
        >
          <el-menu-item index="/homePage/customerManage">
            <i class="el-icon-user"></i>客户管理
          </el-menu-item>
          <el-menu-item index="/homePage/userManage" class="underline">
            <i class="iconfont icon-yonghu"></i>用户管理
          </el-menu-item>
          <el-menu-item index="/homePage/factoryTools" class="underline">
            <i class="iconfont icon-zhongduan"></i>产测工具
          </el-menu-item>
          <el-menu-item index="/homePage/itemCodeManage">
            <i class="el-icon-coin"></i>物料管理
          </el-menu-item>
          <el-menu-item index="/homePage/deviceManage">
            <i class="iconfont icon-xiliehao"></i>SN管理
          </el-menu-item>
          <el-menu-item index="/homePage/archiveMamage" class="underline">
            <i class="el-icon-folder"></i>附件管理
          </el-menu-item>
          <el-menu-item index="/homePage/plantSetting" class="underline">
            <i class="el-icon-setting"></i>工厂设置
          </el-menu-item>
          <el-menu-item @click="clearCacheBtn">
            <i class="iconfont icon-qingkong"></i>清除缓存
          </el-menu-item>
          <el-menu-item index="/homePage/systemLog">
            <i class="iconfont icon-edit"></i>系统日志
          </el-menu-item>
          <el-menu-item index="/homePage/indexPage" class="underline">
            <i class="iconfont icon-tongji"></i>操作排行榜
          </el-menu-item>
          <el-menu-item @click="verBtn">
            <i class="iconfont icon-banbenhao1"></i>版本信息
          </el-menu-item>
          <div class="AIMLogoBox" slot="reference">
            <img src="@/assets/homePageLogo.png" alt />
          </div>
        </el-popover>
        <el-tooltip class="item" effect="dark" content="销售订单" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/customerOrder">
            <i class="iconfont icon-yejiguanli"></i>
            <!-- <i class="el-icon-shopping-cart-full"></i> -->
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="烧录工单" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/outwardOrder">
            <i class="iconfont icon-xinpian"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="SMT工单" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/smtOrder">
            <i class="iconfont icon-smt"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="组装工单" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/productionOrder">
            <i class="iconfont icon-shengchan"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="包装工单" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/cartonOrder">
            <i class="iconfont icon-huowudui"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="品质检验" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/qc">
            <i class="iconfont icon-pinzhi"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="发货工单" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/shipmentOrder">
            <i class="el-icon-truck"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="产品型号" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/productModel">
            <i class="iconfont icon-AIfuwuqipeizhi"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="标签模版" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/labelTemplate">
            <i class="iconfont icon-erweima"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="SAP工单" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/sap">
            <i class="iconfont icon-sap"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="坏件登记" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/badPartsOrder">
            <i class="iconfont icon-bingli"></i>
          </el-menu-item>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="工具箱" placement="right" :open-delay="300">
          <el-menu-item index="/homePage/toolbox">
            <i class="iconfont icon-gongju"></i>
          </el-menu-item>
        </el-tooltip>
      </el-menu>
    </el-aside>
    <el-main>
      <div class="userName">
        <el-dropdown @command="switchTheme" class="themeSwitcher" popper-class="themeDropdown" title="更换系统主题色">
          <span class="themeBtn">
            <i class="iconfont icon-huanfu"></i>
            主题色
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in themeList" :key="item.name" :command="item.name">
              <i class="themeDot" :style="{ backgroundColor: item.color }"></i>
              {{ item.title }}
              <i v-if="currentTheme === item.name" class="el-icon-check themeCheck"></i>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="userBtn darkModeBtn" @click="switchTheme('darkToggle')" :title="darkMode ? '退出护眼深色模式' : '护眼深色模式'">
          <i class="el-icon-moon" v-if="!darkMode"></i>
          <i class="el-icon-sunny" v-else></i>
          护眼
        </span>
        <span class="userBtn productSystemEntry" @click="$router.push('/productSystem')" title="进入生产过站页面">
          <i class="iconfont icon-shengchan"></i>
          生产系统
        </span>
        <el-dropdown @command="userCommand" class="userDropdown">
          <span class="userBtn">
            <i class="el-icon-user-solid"></i>
            {{$store.state.userInfo.name}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-edit" command="changePassword">修改密码</el-dropdown-item>
            <el-dropdown-item icon="iconfont icon-tichu" command="kickOther">踢除其它登录</el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </el-main>
    <myDialog
      title="修改用户密码"
      ref="myDialog"
      width="400px"
      @submitData="submitData"
      @dialogClose="dialogClose"
    >
      <template slot="content">
        <!-- <div class="tips">温馨提示：修改密码不影响登录二维码，如需修改二维码请重新打印！</div> -->
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="旧密码：" size="small" prop="oldPassword">
            <el-input
              type="password"
              v-model="dialogForm.oldPassword"
              placeholder="请输入当前账号密码"
              clearable
              show-password
              @keyup.enter.native="$refs.password.focus"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码：" size="small" prop="password">
            <el-input
              ref="password"
              type="password"
              v-model="dialogForm.password"
              placeholder="请输入新密码"
              clearable
              @keyup.enter.native="$refs.againPwd.focus"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" size="small" prop="againPwd">
            <el-input
              ref="againPwd"
              type="password"
              v-model="dialogForm.againPwd"
              placeholder="请再次输入新密码"
              clearable
              @keyup.enter.native="submitData('修改用户密码')"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </el-container>
</template>

<script>
import myDialog from "@/components/myDialog.vue";
import { apiUserChangePassword, apiUserLogout, apiKickOutOtherLogins } from "@/api/userApi.js";
import { apiCacheFlushAll } from "@/api/cacheApi.js";
import { removeLocalStorage, removeSessionStorage } from "@/utils/myStorage.js";
import { themeList, getTheme, applyTheme, toggleDarkMode, getDarkMode } from "@/utils/theme.js";
export default {
  components: {
    myDialog
  },
  data() {
    return {
      logoPopShow: false,
      // 主题色切换
      themeList: themeList,
      currentTheme: getTheme(),
      darkMode: getDarkMode(),
      dialogForm: {},
      dialogRules: {
        oldPassword: [
          { required: true, message: "当前账号密码不能为空！", trigger: "blur" },
          {
            min: 6,
            max: 64,
            message: "长度在 6 到 64 个字符",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "新密码不能为空！", trigger: "blur" },
          {
            min: 6,
            max: 64,
            message: "长度在 6 到 64 个字符",
            trigger: "blur"
          }
        ],
        againPwd: [
          { required: true, message: "确认密码不能为空！", trigger: "blur" },
          {
            min: 6,
            max: 64,
            message: "长度在 6 到 64 个字符",
            trigger: "blur"
          }
        ]
      },
      labelWidth: "90px"
    };
  },
  methods: {
    // 切换主题色 / 护眼深色模式
    switchTheme(name) {
      if (name === 'darkToggle') {
        this.darkMode = toggleDarkMode();
        return;
      }
      applyTheme(name);
      this.currentTheme = name;
    },
    // 用户名下拉菜单
    userCommand(command) {
      if (command == "changePassword") {
        this.changePassword();
      } else if (command == "kickOther") {
        this.kickOtherBtn();
      } else if (command == "logout") {
        this.logOutBtn();
      }
    },
    // 踢除其它登录
    kickOtherBtn() {
      this.$confirm("是否将其它异地登录都踢除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiKickOutOtherLogins();
        this.$message({
          message: res.msg,
          type: res.code == 0 ? "success" : "error"
        });
      });
    },
    // 修改密码
    changePassword() {
      this.logoPopShow = false;
      this.$refs.myDialog.dialogVisible = true;
    },
    // 确认修改
    submitData(title) {
      // console.log(title);
      if (title == "修改用户密码") {
        this.$refs.dialogForm.validate(async valid => {
          if (valid) {
            if (this.dialogForm.password == this.dialogForm.againPwd) {
              const res = await apiUserChangePassword({
                ...this.dialogForm
              });
              // console.log(res)
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.$router.push("/login");
                this.$store.state.userInfo = {};
                removeLocalStorage("userInfo");
                removeSessionStorage("userInfo");
                this.$message({
                  message: "密码修改成功,请重新登录",
                  type: "success"
                });
              }
            } else {
              this.$message({
                type: "error",
                message: "新密码与确认密码不一致"
              });
            }
          } else {
            return false;
          }
        });
      }
    },
    // 对话框关闭
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },    
    verBtn() {        
      this.$alert(
        <span>
          版本号：V1.1.1 build 20231223
        </span>,
        <span>
          &copyright;深圳奥尼电子股份有限公司
        </span>,
        "版本信息",
        {
          confirmButtonText: "确定",
        }
      );
    },
    // 清除缓存
    clearCacheBtn() {
      this.$confirm("缓存能减轻数据库访问压力，清除后将重新加载缓存！", "清理缓存", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiCacheFlushAll({});
        this.$message({
          message: res.msg,
          type: res.code == 0 ? "success" : "error"
        });
      });
    },
    // 退出登录
    logOutBtn() {
      this.logoPopShow = false;
      this.$confirm("确认退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiUserLogout();
        // console.log(res);
        if (res.code == 0) {
          this.$store.state.userInfo = {};
          this.$store.state.directVisitUrl = "";
          removeLocalStorage("userInfo");
          removeSessionStorage("userInfo");
          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "退出登录"
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.homePage {
  height: 100%;
  .el-aside {
    .el-menu {
      width: 60px;
      height: 100%;
      border-right: 0px;
      .AIMLogoBox {
        width: 60px;
        height: 56px;
        text-align: center;
        cursor: pointer;
        img {
          margin-top: 9px;
        }
        &:hover {
          background-color: var(--themeColorDark);
        }
      }
      .el-menu-item {
        padding: 0 !important;
        text-align: center;
        i {
          color: #fff;
        }
      }
      .el-menu-item.is-active {
        i {
          color: #606266;
        }
      }
    }
  }
  .el-main {
    position: relative;
    padding: 0;
    background-color: var(--bgPage);
    overflow: hidden;
    .userName {
      line-height: 20px;
      position: fixed;
      top: 10px;
      right: 20px;
      z-index: 1;
      color: var(--textRegular);
      .themeSwitcher {
        margin-right: 10px;
        cursor: pointer;

        .themeBtn {
          color: var(--themeColor);
        }
      }

      .productSystemEntry {
        margin-right: 10px;
        cursor: pointer;
      }

      // 生产系统入口与用户名（均为 .userBtn）同换肤按钮使用主题色，图标色随文字继承
      .userBtn {
        color: var(--themeColor);
      }

      .darkModeBtn {
        margin-right: 10px;
        cursor: pointer;

        i {
          font-size: 16px;
        }
      }

      .userDropdown {
        cursor: pointer;
      }
    }

    // 窄屏时自动隐藏主题色、护眼、生产系统按钮，仅保留用户名下拉
    @media (max-width: 768px) {
      .userName {
        .themeSwitcher,
        .darkModeBtn,
        .productSystemEntry {
          display: none;
        }
      }
    }
  }
  // /deep/.myDialog {
  //   .el-dialog__body {
  //     padding-top: 0;
  //   }
  // }
}
</style>

<!-- 左侧主菜单栏深色模式（非 scoped，因为 .theme-dark 在 html 上无 data-v 属性） -->
<style lang="less">
.theme-dark .el-menu-vertical-demo {
  background-color: var(--bgPanel) !important;

  // Element UI 会把 background-color 内联到每个 li.el-menu-item 上，需逐个覆盖
  .el-menu-item {
    background-color: var(--bgPanel) !important;

    i {
      color: var(--textSecondary) !important;
    }
  }

  .AIMLogoBox:hover {
    background-color: var(--bgHover) !important;
  }

  .el-menu-item:hover {
    background-color: var(--bgHover) !important;

    i {
      color: var(--textPrimary) !important;
    }
  }

  .el-menu-item.is-active i {
    color: var(--textPrimary) !important;
  }
}
</style>